import React from 'react'
import { SearchResultPartyDetails } from '@Entities/party-details'
import SearchResultPartyDetailsCard from '@Components/Search/SearchByParty/SearchResultPartyDetailsCard'
import CheckBox from '@Components/Selectors/Checkbox'

interface MultiplePublisherSelectorDetailCardProps {
    partyDetails: SearchResultPartyDetails
    onTitleClick: (partyDetails: SearchResultPartyDetails) => void
    isSelected: boolean
    onToggle: () => void
}

const MultiplePublisherSelectorDetailCard = ({
    partyDetails,
    onTitleClick,
    isSelected,
    onToggle,
}: MultiplePublisherSelectorDetailCardProps) => {
    const checkboxId = partyDetails.ipId || partyDetails.hfaPublisherNumber || partyDetails.name

    return (
        <SearchResultPartyDetailsCard partyDetails={partyDetails} onTitleClick={onTitleClick}>
            <CheckBox
                id={checkboxId}
                mainColor
                checked={isSelected}
                className="publisher-toggle-checkbox"
                ariaLabel={(isSelected ? 'Remove' : 'Add') + ' publisher ' + partyDetails.name}
                onClick={() => onToggle()}
            />
        </SearchResultPartyDetailsCard>
    )
}

export default MultiplePublisherSelectorDetailCard
